export default __webpack_public_path__ + "static/media/grenouillemaison.4881a37b.png";